import { createContext, useContext, useCallback } from 'react';
import { toast } from '../services/toast';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const showError = useCallback((message) => {
    toast.error(message || 'An error occurred');
  }, []);

  const showSuccess = useCallback((message) => {
    toast.success(message || 'Success');
  }, []);

  const value = { showError, showSuccess };
  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  return context || {
    showError: (msg) => toast.error(msg || 'An error occurred'),
    showSuccess: (msg) => toast.success(msg || 'Success'),
  };
}

export default ToastContext;
